import { createPortal } from "react-dom";
import { useAppState } from "../../hooks/useAppState";
import { getVanillaEl } from "../../domBridge";
import { appState } from "../../../state";
import { notifyStateChange } from "../../../stateBus";

// Entry point for Memories Reel - a reel is inherently album-scoped, so
// this only appears in album detail, not "All Media" (ReelDialog still
// owns its own album picker, so it works from a more generic entry point
// too if one gets added later). Same getVanillaEl-anchor + createPortal
// pattern as SortToolbar.tsx.
export function ReelButton() {
  const currentAlbum = useAppState((s) => s.currentAlbum);
  const anchor = getVanillaEl<HTMLDivElement>("reelBtnAnchor");

  if (!anchor || currentAlbum === "all") return null;

  function handleClick(): void {
    appState.reelDialogOpen = true;
    notifyStateChange();
  }

  return createPortal(
    <button type="button" className="album-quick-action" aria-label="Play a Memories Reel" onClick={handleClick}>
      <span className="album-quick-action-icon">
        <i className="bi bi-play-fill" aria-hidden="true" />
      </span>
      <span>Play</span>
    </button>,
    anchor,
  );
}
